var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeeting = function SvgMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 8.082)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9700",
    d: "M32.106 39.463c4.18.001 7.569-3.368 7.57-7.525 0-4.157-3.386-7.527-7.565-7.529-4.18 0-7.569 3.368-7.57 7.525a7.5 7.5 0 0 0 2.215 5.323 7.6 7.6 0 0 0 5.35 2.206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M32.068 54.563a4.57 4.57 0 0 1 4.225 2.806 4.53 4.53 0 0 1-.99 4.956 4.59 4.59 0 0 1-4.983.985 4.55 4.55 0 0 1-2.821-4.202c0-2.51 2.045-4.545 4.569-4.545"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.085,
    height: 12.084,
    x: 27.524,
    y: 42.483,
    fill: "#00A4E0",
    rx: 2.396,
    transform: "rotate(180 32.067 48.525)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M32.068 9.278c-2.524 0-4.57-2.035-4.57-4.545S29.545.188 32.069.188s4.57 2.035 4.57 4.545-2.046 4.545-4.57 4.545"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.085,
    height: 12.084,
    x: 27.526,
    y: 9.278,
    fill: "#00A4E0",
    rx: 2.396
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M9.313 31.934a4.55 4.55 0 0 1-2.821 4.203 4.59 4.59 0 0 1-4.983-.986 4.53 4.53 0 0 1-.99-4.956 4.57 4.57 0 0 1 4.225-2.806c1.212 0 2.374.48 3.23 1.331a4.53 4.53 0 0 1 1.339 3.214m0 2.123v-4.244a2.396 2.396 0 0 1 2.396-2.396h7.357a2.396 2.396 0 0 1 2.396 2.396v4.244a2.396 2.396 0 0 1-2.396 2.396H11.71a2.396 2.396 0 0 1-2.396-2.396Zm45.51-2.123a4.55 4.55 0 0 1 2.821-4.202 4.59 4.59 0 0 1 4.983.985 4.53 4.53 0 0 1 .99 4.956 4.57 4.57 0 0 1-4.225 2.806c-2.523 0-4.569-2.035-4.569-4.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M54.823 29.813v4.244a2.396 2.396 0 0 1-2.396 2.396H45.07a2.396 2.396 0 0 1-2.396-2.396v-4.244a2.396 2.396 0 0 1 2.396-2.396h7.357a2.396 2.396 0 0 1 2.396 2.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "M15.979 47.94a4.53 4.53 0 0 1 .991 4.954 4.57 4.57 0 0 1-4.223 2.808 4.57 4.57 0 0 1-4.224-2.808 4.53 4.53 0 0 1 .992-4.955 4.59 4.59 0 0 1 6.464 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "m17.5 49.452-3.026-3.01a2.396 2.396 0 0 1 0-3.398l5.193-5.165a2.396 2.396 0 0 1 3.38 0l3.026 3.01a2.396 2.396 0 0 1 0 3.398l-5.193 5.165c-.935.93-2.445.93-3.38 0m30.657-33.519a4.53 4.53 0 0 1-.991-4.955 4.57 4.57 0 0 1 4.223-2.807 4.57 4.57 0 0 1 4.224 2.807 4.53 4.53 0 0 1-.992 4.955 4.59 4.59 0 0 1-6.464 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "m46.636 14.42 3.027 3.01a2.396 2.396 0 0 1 0 3.398l-5.193 5.165c-.935.93-2.445.93-3.38 0l-3.026-3.01a2.396 2.396 0 0 1 0-3.398l5.193-5.165a2.396 2.396 0 0 1 3.38 0Zm-30.657 1.513a4.59 4.59 0 0 1-4.982.987 4.55 4.55 0 0 1-2.823-4.201 4.55 4.55 0 0 1 2.823-4.201 4.59 4.59 0 0 1 4.982.986 4.53 4.53 0 0 1 0 6.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "m14.474 17.427 3.027-3.01a2.396 2.396 0 0 1 3.38 0l5.193 5.165a2.396 2.396 0 0 1 0 3.397l-3.027 3.01c-.935.93-2.445.93-3.38 0l-5.193-5.164a2.396 2.396 0 0 1 0-3.398M48.157 47.94a4.59 4.59 0 0 1 4.982-.987 4.55 4.55 0 0 1 2.823 4.2 4.55 4.55 0 0 1-2.823 4.202 4.59 4.59 0 0 1-4.982-.987 4.53 4.53 0 0 1 0-6.429"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "m49.661 46.443-3.026 3.01c-.935.93-2.445.93-3.38 0l-5.193-5.165a2.396 2.396 0 0 1 0-3.397l3.027-3.01a2.396 2.396 0 0 1 3.38 0l5.192 5.165a2.396 2.396 0 0 1 0 3.397"
  }))));
};
export default SvgMeeting;